<template>
  <div>
    <report-viewer />
  </div>
</template>

<script>
  import ReportViewer from '@/components/reports/ReportViewer.vue'

  export default {
    components: {
      ReportViewer
    }
  }
</script>
